import { useState, useCallback } from "react";

import BaseSearchWithFilters from "../../../../search-with-filters";
import { UniformFilterObject } from "../../../../search-with-filters/src/utils/types";
import {
    useSetFilter,
    useFilterOptions,
    useFilter,
    useSetSearch
} from "../../context/hooks.ts";

export const SearchWithFilters = () => {
    const [searchStringValue, setSearchStringValue] = useState("");
    const [searchInputFieldFocused, setSearchInputFieldFocused] =
        useState(false);

    const setFilter = useSetFilter();
    const setSearch = useSetSearch();

    const appValue = useFilter("selectedProduct");
    const statusValue = useFilter("status");
    const categoryValue = useFilter("category");

    const appOptions = useFilterOptions("selectedProduct");
    const statusOptions = useFilterOptions("status");
    const categoryOptions = useFilterOptions("category");

    const [filterObject, setFilterObject] = useState<UniformFilterObject>({
        app: appOptions.reduce((acc, opt) => {
            const isSelected = appValue.includes(opt.label);
            return {
                ...acc,
                [opt.label]: {
                    committedActive: isSelected,
                    stagedActive: isSelected
                }
            };
        }, {}),
        category: categoryOptions.reduce((acc, opt) => {
            const isSelected = categoryValue.includes(opt.label);
            return {
                ...acc,
                [opt.label]: {
                    committedActive: isSelected,
                    stagedActive: isSelected
                }
            };
        }, {}),
        status: statusOptions.reduce((acc, opt) => {
            const isSelected = statusValue.includes(opt.label);
            return {
                ...acc,
                [opt.label]: {
                    committedActive: isSelected,
                    stagedActive: isSelected
                }
            };
        }, {})
    });

    const clearSearchField = useCallback(() => {
        setSearchStringValue("");
        setSearchInputFieldFocused(false);
        setSearch("");
    }, [setSearch]);

    const runSearchWithFilters = useCallback(
        (filterObj: UniformFilterObject, searchTerm: string) => {
            setFilterObject(filterObj);

            // search
            setSearch(searchTerm);

            // app (selectedProduct) filter
            const appFilterValue: string[] = [];
            Object.entries(filterObj.app).map(
                ([label, { committedActive }]) => {
                    if (committedActive) {
                        const option = appOptions.find(
                            (opt) => opt.label === label
                        );
                        if (option) {
                            appFilterValue.push(option.value);
                        }
                    }
                }
            );
            setFilter("selectedProduct", appFilterValue);

            // category filter
            const categoryFilterValue: string[] = [];
            Object.entries(filterObj.category).map(
                ([label, { committedActive }]) => {
                    if (committedActive) {
                        const option = categoryOptions.find(
                            (opt) => opt.label === label
                        );
                        if (option) {
                            categoryFilterValue.push(option.value);
                        }
                    }
                }
            );
            setFilter("category", categoryFilterValue);

            // status filter
            const statusFilterValue: string[] = [];
            Object.entries(filterObj.status).map(
                ([label, { committedActive }]) => {
                    if (committedActive) {
                        const option = statusOptions.find(
                            (opt) => opt.label === label
                        );
                        if (option) {
                            statusFilterValue.push(option.value);
                        }
                    }
                }
            );
            setFilter("status", statusFilterValue);
        },
        [appOptions, categoryOptions, statusOptions, setFilter, setSearch]
    );

    return (
        <BaseSearchWithFilters
            filterObject={filterObject}
            searchStringValue={searchStringValue}
            searchInputFieldFocused={searchInputFieldFocused}
            setSearchInputFieldFocused={setSearchInputFieldFocused}
            setFilterObjectValue={setFilterObject}
            setSearchString={setSearchStringValue}
            clearSearchField={clearSearchField}
            runSearchWithFilters={runSearchWithFilters}
        />
    );
};
